<template>
  <div v-if="loadComponent">
    <v-container>
      <h1 class="pb-1 mb-1">Bank Information</h1>
      <pagination>
        <!-- <template slot="actions" slot-scope="{item}">
          <v-btn @click.stop="edit(item)" text icon>
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click.stop="deleteItem(item)" text icon>
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>-->
      </pagination>
    </v-container>
  </div>
</template>
<script>
import Pagination from "./Pagination";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
export default {
  mixins: [userAccessMixin],
  components: {
    Pagination
  },
  created() {
    this.getUserAccessRights("BankCode");
  }
};
</script>